<template>
  <div>
    <homepage>
      <div class="m-block">
        <h2>{{ pageTitle }}</h2>
        <div v-if="this.$i18n.locale === 'pt'" v-html="this.content.portugueseBody"></div>
        <div v-if="this.$i18n.locale === 'en'" v-html="this.content.englishBody"></div>
      </div>
      <slot></slot>
    </homepage>
  </div>
</template>
<script>
import Homepage from '@/pages/portal/Homepage'
import CmsClient from '@/services/resource_client/cms'
export default {
  name: 'CmsTemplate',
  components: { Homepage },
  props: [ 'pageName', 'pageTitle' ],
  data: function () {
    return {
      content: ''
    }
  },
  mounted () {
    CmsClient.get(this.pageName)
    .then(r => { this.content = r.data })
    .catch(e => {
      if (e.response.status !== 404) {
        throw e
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// CmsTemplate.vue?c1cd475a